module.exports = __webpack_public_path__ + "static/media/es-ct.46e9ce9e.svg";